import { Component } from '@angular/core';

@Component({
  selector: 'app-icon-error',
  templateUrl: './icon-error.component.svg',
  styleUrls: ['./icon-error.component.css'],
})
export class IconErrorComponent {}
